import { z } from "zod";
import { defineStepConfig } from "../registry/helpers";
import { actionBoundaryConfigSchema } from "../utils/action-interfaces";

export const actionInputStep = defineStepConfig({
  type: "action_input",
  name: "Action Input",
  description:
    "Entry point for reusable workflow actions. Output sockets are derived from connected downstream inputs.",
  category: "Trigger",
  inputSchema: z.never(),
  outputSchema: z.record(z.string(), z.unknown()),
  configSchema: actionBoundaryConfigSchema,
  emits: [] as const,
});
